import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import "./App.css";
import Product from "./components/product";

function App() {
  return (
    <div className="container-fluid">
      <Switch>
      <Route path="/landings/:productSlug" component={Product} />
      <Route path="/:productSlug" component={Product} />
        
        <Redirect from="/" exact to="/heliosmax" />
        <Redirect to="/not-found" />
      </Switch>

      
    </div>
  );
}

export default App;
